import { start } from '@popperjs/core';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import BtnIcon from '../buttons/btn_icon';

const SectionHeader = ({
	align = start,
	className,
	excerpt,
	headingType = 'h2',
	hideButton = false,
	linkType,
	resetSpacing = false,
	size = 'md',
	subHeadingType = 'p',
	subTitle,
	title,
	to,
	variant = 'dark',
	...props
}) => {
	const HeadingComponent = headingType;
	const SubHeadingComponent = subHeadingType;

	const sizes = {
		lg: {
			btnIconSize: 'lg',
			subTitleSize: 'lead',
			titleSize: 'title-lg',
		},
		md: {
			btnIconSize: 'lg',
			subTitleSize: 'lead',
			titleSize: 'section-title',
		},
		sm: {
			btnIconSize: 'md',
			subTitleSize: 'base',
			titleSize: 'section-title-sm',
		},
	};

	const variants = {
		dark: {
			btnIcon: 'light',
			excerpt: 'text-muted',
			subTitle: 'muted',
			title: 'text-dark',
		},
		light: {
			btnIcon: 'dark',
			excerpt: 'text-white o-50',
			subTitle: 'text-white o-50',
			title: 'text-white',
		},
		primary: {
			btnIcon: 'dark',
			excerpt: '',
			subTitle: 'text-white o-50',
			title: 'text-primary',
		},
		success: {
			btnIcon: 'dark',
			excerpt: '',
			subTitle: 'text-white o-50',
			title: 'text-success',
		},
	};

	const aligns = {
		center: {
			excerpt: 'mx-auto text-center',
			subTitle: 'text-center',
			title: 'center text-center',
		},
		start: {
			excerpt: '',
			subTitle: '',
			title: 'start',
		},
	};

	return (
		<>
			<div
				className={`section-header ${
					resetSpacing == true ? '' : 'mb-lg-5 mb-4'
				}`}
			>
				{subTitle && (
					<SubHeadingComponent
						className={` mb-0 ${aligns[align].subTitle} ${sizes[size].subTitleSize} ${variants[variant].subTitle}`}
					>
						{subTitle}
					</SubHeadingComponent>
				)}
				<div
					className={`d-flex align-items-center justify-content-${aligns[align].title}`}
				>
					<HeadingComponent
						className={`mb-0 me-2 ${className}  ${sizes[size].titleSize}  ${variants[variant].title} `}
					>
						{title}
					</HeadingComponent>

					{!hideButton && (
						<BtnIcon
							aria-label={title}
							iconSize={sizes[size].btnIconSize}
							linkType={linkType}
							to={to}
							variant={variants[variant].btnIcon}
							{...props}
						>
							<ArrowRightShort />
						</BtnIcon>
					)}
				</div>
				{excerpt && (
					<div
						className={`section-excerpt-container mt-3 ${aligns[align].excerpt}`}
					>
						<p className={`section-excerpt ${variants[variant].excerpt} `}>
							{excerpt}
						</p>
					</div>
				)}
			</div>
		</>
	);
};

SectionHeader.propTypes = {
	align: PropTypes.string,
	className: PropTypes.string,
	excerpt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	headingType: PropTypes.string,
	hideButton: PropTypes.bool,
	linkType: PropTypes.string,
	resetSpacing: PropTypes.bool,
	size: PropTypes.string,
	subHeadingType: PropTypes.string,
	subTitle: PropTypes.node,
	title: PropTypes.string,
	to: PropTypes.string,
	variant: PropTypes.string,
};

export default SectionHeader;
